module.exports = __webpack_public_path__ + "img/carousel-item-2.743f70e4.png";